import { Base64 } from 'js-base64';

export function getJSONObjectFromBase64URL(base64url) {
  if (typeof base64url !== 'string') {
    return false;
  }
  let json;
  try {
    // note .decodeURI() is unnecessary since it accepts both flavors
    json = Base64.decode(base64url)
  } catch(e) {
    return false;
  }
  let value;
  try {
    value = JSON.parse(json);
  } catch(e) {
    return false;
  }
  if (typeof value !== 'object' || Array.isArray(value)) {
    return false;
  }
  return value;
}

function isSameAudience(provided, expected) {
  if (Array.isArray(provided)) {
    const found = provided.find(item => isSameAudience(item, expected));
    return !!found;
  }
  return provided === expected;
}

export function getTokenParts(token) {
  if (typeof token !== 'string') {
    return false;
  }
  // A JWT has three parts which are split by a dot
  const split = token.split('.', 3);
  if (split.length !== 3) {
    return false;
  }
  // Index 0 is the index of the JWT
  const header = getJSONObjectFromBase64URL(split[0]);
  // Index 1 is the payload of the JWT
  const payload = getJSONObjectFromBase64URL(split[1]);
  // Index 2 is the signature of the JWT
  if (!header || !payload || typeof split[2] !== 'string') {
    return false;
  }
  return {
    header,
    payload
  };
}

export function getPayload(token) {
  const parts = getTokenParts(token);
  return parts ? parts.payload : null;
}

export function getTokenExpiresAt(token) {
  const payload = getPayload(token);
  if (!(payload && payload.exp)) {
    return null;
  }
  return payload.exp * 1000;
}

export function isJsonWebTokenValid(token, audience) {
  const parts = getTokenParts(token);
  if (!parts) {
    return false;
  }
  const { header, payload } = parts;
  // If the header has typ, and it is not "JWT" then it is invalid
  if (header.typ && (typeof header.typ !== 'string' || header.typ.toUpperCase() !== 'JWT')) {
    return false;
  }
  // We define the audience when we request the authentication, so ensure it matches
  if (audience && !isSameAudience(payload.aud, audience)) {
    return false;
  }
  // If the payload has no "exp" property, then the token does not expire
  if (!payload.exp) {
    return true;
  }
  // exp is in seconds (AKA NumericDate https://tools.ietf.org/html/rfc7519#section-4.1.4)
  // We aren't validating any other values, for example nbf or iss as I don't believe we will utilise them, or they aren't easily testable
  // We also don't validate the signature of the token as that is done on the server side
  // Any server requests that come back with unauthorised will trigger a re-authentication
  const expiresAt = payload.exp * 1000;
  return expiresAt > Date.now();
}


// WEBPACK FOOTER //
// ./src/services/json-web-token.js